<div class="www-act-end">
  <a (click)="onClose()" type="button" class="www-act-end__close-btn" style="min-width: 0">
    <span>&#10005;</span>
  </a>
  <div class="www-act-end__content" [innerHTML]="sanitizedText()"></div>
</div>

